'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');

var _lodash = require('lodash');

var _validationService = require('../../../common/validation/validationService');

var _validationService2 = _interopRequireDefault(_validationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getFormState = function getFormState(state, reduxMountPoint) {
    return state.get(reduxMountPoint);
};

exports.default = function (config, customMapStateToForm) {
    return function (DecoratedComponent) {
        var _dec, _class;

        /**
         *
         * @param values
         * @param props
         * @returns {{}}
         */
        var validate = function validate(values, props) {
            return (0, _validationService2.default)(values, config.fieldsConfig).errors;
        };

        var defaultConfig = {
            getFormState: getFormState,
            touchOnChange: true,
            touchOnBlur: false,
            validate: validate
        };

        // Create the redux form config by combining the input config with the default config
        var reduxFormConfig = _extends({}, defaultConfig, config, {
            fields: Object.keys(config.fieldsConfig)
        });

        var internalMapStateToForm = function internalMapStateToForm(state) {
            var customState = customMapStateToForm ? customMapStateToForm(state) : undefined;

            var form = state.get('form')[config.form];

            return _extends({}, customState, {
                primaryError: form && form.primaryError
            });
        };

        var MilanoteForm = (_dec = (0, _reduxForm.reduxForm)(reduxFormConfig, internalMapStateToForm), _dec(_class = function (_React$Component) {
            _inherits(MilanoteForm, _React$Component);

            _createClass(MilanoteForm, null, [{
                key: 'showError',
                value: function showError(_ref) {
                    var field = _ref.field,
                        submitFailed = _ref.submitFailed,
                        currentErrorMessage = _ref.currentErrorMessage,
                        awaitingDebounce = _ref.awaitingDebounce;

                    // If there's no errors, don't show any validation messages
                    var isError = !field.isValid && field.error;
                    if (!isError) return false;

                    // If the error message hasn't changed, then continue to show it
                    if (currentErrorMessage && currentErrorMessage === field.error.message) return true;

                    // Show the error if it should be shown before submit or it shouldn't be shown before submit, but there's been a
                    // submission
                    return (!field.error.hideBeforeSubmit || field.error.hideBeforeSubmit && submitFailed) && (
                    // And only show if it should be shown when touched, or it shouldn't and the field hasn't been touched
                    !field.error.hideIfTouched || field.error.hideIfTouched && !field.touched)
                    // And only show if the error is not debounced, or it is debounced and the field is not active or we're
                    // not waiting for the debounce to finish
                    && (!field.error.debounced || field.error.debounced && (!field.active || !awaitingDebounce));
                }
            }]);

            function MilanoteForm(props) {
                _classCallCheck(this, MilanoteForm);

                var _this = _possibleConstructorReturn(this, (MilanoteForm.__proto__ || Object.getPrototypeOf(MilanoteForm)).call(this, props));

                var debounceHandler = (0, _lodash.debounce)(function () {
                    _this.debounce.waiting = false;
                    _this.getErrorMessages(_this.props);
                }, 3000);

                _this.debounce = {
                    waiting: false,
                    handler: debounceHandler
                };

                _this.state = {
                    newSubmission: false,
                    sanitisedErrors: {},
                    showingErrors: false,
                    dirtySinceSubmission: false
                };

                _this.onChange = _this.onChange.bind(_this);
                _this.submitInterceptor = _this.submitInterceptor.bind(_this);

                _this.getSanitisedError = _this.getSanitisedError.bind(_this);
                _this.getErrorMessages = _this.getErrorMessages.bind(_this);
                return _this;
            }

            /**
             * Whenever the validation error messages change we need to check to see if we should show them.
             */


            _createClass(MilanoteForm, [{
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    this.getErrorMessages(nextProps);
                }
            }, {
                key: 'componentWillUpdate',
                value: function componentWillUpdate(nextProps, nextState) {
                    var newSubmission = nextState.newSubmission;


                    if (newSubmission) {
                        var untouchAll = nextProps.untouchAll;

                        untouchAll();
                        this.setState({ newSubmission: false });
                    }
                }

                /**
                 * Cancel the debounce timer when unmounting.
                 */

            }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.debounce.handler.cancel();
                }

                /**
                 * Inercept the usual field onChange handler to begin the debounce tiemr.
                 */

            }, {
                key: 'onChange',
                value: function onChange(fieldName) {
                    var _this2 = this;

                    return function (event) {
                        var fields = _this2.props.fields;


                        _this2.debounce.waiting = true;
                        _this2.debounce.handler();

                        _this2.setState({
                            dirtySinceSubmission: true
                        });

                        fields[fieldName].onChange(event);
                    };
                }

                /**
                 * Loops through every field and determines the sanitised error (based on the validation errors and the current
                 * state of the form - i.e. if the user is still typing).
                 */

            }, {
                key: 'getErrorMessages',
                value: function getErrorMessages(props) {
                    var fields = props.fields;


                    var sanitisedErrors = {};
                    var showingErrors = false;
                    for (var fieldName in fields) {
                        if (!fields.hasOwnProperty(fieldName)) continue;

                        sanitisedErrors[fieldName] = this.getSanitisedError(props, fieldName);
                        showingErrors = showingErrors || sanitisedErrors[fieldName].showError;
                    }
                    this.setState({ sanitisedErrors: sanitisedErrors, showingErrors: showingErrors });
                }

                /**
                 * Get an error object describing whether an error should be shown for the specified field, and what the error
                 * message, if any, should be.
                 */

            }, {
                key: 'getSanitisedError',
                value: function getSanitisedError(props, fieldName) {
                    var fields = props.fields,
                        submitFailed = props.submitFailed;

                    var field = fields[fieldName];

                    var sanitisedError = {};
                    var currentErrorMessage = this.state.sanitisedErrors[fieldName] && this.state.sanitisedErrors[fieldName].message;
                    var awaitingDebounce = this.debounce.waiting;

                    sanitisedError.showError = MilanoteForm.showError({
                        submitFailed: submitFailed,
                        field: field,
                        currentErrorMessage: currentErrorMessage,
                        awaitingDebounce: awaitingDebounce
                    });

                    sanitisedError.message = sanitisedError.showError ? field.error.message : null;

                    return sanitisedError;
                }

                /**
                 * Intercepts the submission to first set state so that the componentWillUpdate can recognise that a submission
                 * has just occurred.
                 */

            }, {
                key: 'submitInterceptor',
                value: function submitInterceptor(event) {
                    var handleSubmit = this.props.handleSubmit;

                    // Set the state to say a new submission was attempted so the componentWillUpdate can set the state of
                    // fields correctly so that validation errors will be displayed

                    this.setState({ newSubmission: true, dirtySinceSubmission: false });

                    // Force the debounce handlers to fire immediately on submission
                    this.debounce.handler.flush();

                    handleSubmit(event);
                }
            }, {
                key: 'render',
                value: function render() {
                    var _state = this.state,
                        sanitisedErrors = _state.sanitisedErrors,
                        showingErrors = _state.showingErrors,
                        dirtySinceSubmission = _state.dirtySinceSubmission;

                    return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
                        submitInterceptor: this.submitInterceptor,
                        onChange: this.onChange,
                        sanitisedErrors: sanitisedErrors,
                        showingErrors: showingErrors,
                        dirtySinceSubmission: dirtySinceSubmission }));
                }
            }]);

            return MilanoteForm;
        }(_react2.default.Component)) || _class);


        MilanoteForm.propTypes = {
            handleSubmit: _propTypes2.default.func,
            submitFailed: _propTypes2.default.bool,
            fields: _propTypes2.default.object
        };

        return MilanoteForm;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/milanoteForm.js
// module id = 104
// module chunks = 0